import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint';
import { useRouter } from 'next/router';
import React, { FC } from 'react';
import { useRecoilValue } from 'recoil';

import {
  borderClassName,
  borderColorClassName,
  borderT,
  headerHeight,
} from '@/components/PlatformSubscription/PlanTable';
import {
  columnWidth,
  columnWidthSmall,
  getStructuredPlanData,
  SubscriptionButtonTitle,
} from '@/components/PlatformSubscription/PlanTable/Columns';
import Cell from '@/components/PlatformSubscription/PlanTable/Columns/Cell';
import HeaderCell from '@/components/PlatformSubscription/PlanTable/Columns/HeaderCell';
import MainHCell from '@/components/PlatformSubscription/PlanTable/Columns/MainHCell';

import { user } from '@/atoms/user';
import { getSubPlanName } from '@/pages/gems-transactions';
import { IPlan } from '@/utils/interfaces/Subscription';
interface Props {
  plans?: IPlan[];
  plan?: IPlan;
  setSelectedPlan: React.Dispatch<React.SetStateAction<IPlan | undefined>>;
  subscriptionHandle: (buttonTitle: SubscriptionButtonTitle) => Promise<void>;
}
const SingleColumn: FC<Props> = ({
  setSelectedPlan,
  subscriptionHandle,
  plan,
}) => {
  const screens = useBreakpoint();
  const router = useRouter();
  const isAffiliate = router?.pathname?.includes('affiliate');
  // const plan = plans?.find((i) => i.name === PlanNameEnum.Plus);
  const userState = useRecoilValue(user);

  return (
    <div
      className={`
  ${borderClassName}
  ${borderColorClassName}
  rounded-xl flex  overflow-hidden flex-col box-border
  `}
    >
      <div style={{ height: headerHeight }} className='flex flex-col'>
        <MainHCell
          subTitle={plan?.name}
          title={plan ? getSubPlanName(plan?.name) : ''}
        />

        <HeaderCell
          bestValue={
            plan
              ? getStructuredPlanData(plan, userState, 'platform').bestValue
              : false
          }
          disabled={
            plan
              ? getStructuredPlanData(plan, userState, 'platform').disabled
              : false
          }
          title={
            plan
              ? isAffiliate
                ? getStructuredPlanData(plan, userState, 'platform').billed
                : 'Billed ' +
                  getStructuredPlanData(plan, userState, 'platform').billed
              : ''
          }
          price={
            plan &&
            getStructuredPlanData(plan, userState, 'platform').monthlyPrice
              ? getStructuredPlanData(plan, userState, 'platform').monthlyPrice
              : plan && getStructuredPlanData(plan, userState, 'platform').price
                ? getStructuredPlanData(plan, userState, 'platform').price
                : ''
          }
          priceCut={isAffiliate ? '4999' : '/Month'}
          buttonTitle={
            plan
              ? getStructuredPlanData(plan, userState, 'platform').buttonTitle
              : ''
          }
          buttonTooltip={
            plan
              ? getStructuredPlanData(plan, userState, 'platform').buttonTooltip
              : ''
          }
          onClick={() => {
            setSelectedPlan(plan);
            plan &&
              subscriptionHandle(
                getStructuredPlanData(plan, userState, 'platform').buttonTitle,
              );
          }}
          expText={
            plan
              ? getStructuredPlanData(plan, userState, 'platform').expiresIn
              : ''
          }
        />
      </div>
      <div>
        <Cell
          className={`
            ${borderColorClassName}
             ${borderT}
            `}
          classes={{
            childDivClass: 'justify-center',
            pClass: 'text-center',
          }}
          title={
            plan
              ? getStructuredPlanData(plan, userState, 'platform').whatInside
              : ''
          }
          style={{
            width: screens.xl ? `${columnWidth}px` : `${columnWidthSmall}px`,
            maxWidth: screens.xl ? `${columnWidth}px` : `${columnWidthSmall}px`,
          }}
        />

        <Cell
          className={`
            ${borderColorClassName}
            `}
          classes={{
            childDivClass: 'justify-center',
            pClass: 'text-center',
          }}
          icon={
            plan
              ? getStructuredPlanData(plan, userState, 'platform').certification
              : false
          }
          style={{
            width: screens.xl ? `${columnWidth}px` : `${columnWidthSmall}px`,
            maxWidth: screens.xl ? `${columnWidth}px` : `${columnWidthSmall}px`,
          }}
        />
        <Cell
          className={`
            ${borderColorClassName}
            `}
          classes={{
            childDivClass: 'justify-center',
            pClass: 'text-center',
          }}
          icon={
            plan
              ? getStructuredPlanData(plan, userState, 'platform').videoBook
              : false
          }
          style={{
            width: screens.xl ? `${columnWidth}px` : `${columnWidthSmall}px`,
            maxWidth: screens.xl ? `${columnWidth}px` : `${columnWidthSmall}px`,
          }}
        />
        <Cell
          className={`
            ${borderColorClassName}
            `}
          classes={{
            childDivClass: 'justify-center',
            pClass: 'text-center',
          }}
          icon={
            plan
              ? getStructuredPlanData(plan, userState, 'platform').audioBook
              : false
          }
          style={{
            width: screens.xl ? `${columnWidth}px` : `${columnWidthSmall}px`,
            maxWidth: screens.xl ? `${columnWidth}px` : `${columnWidthSmall}px`,
          }}
        />

        <Cell
          className={`
            ${borderColorClassName}
            `}
          classes={{
            childDivClass: 'justify-center',
            pClass: 'text-center',
          }}
          icon={
            plan
              ? getStructuredPlanData(plan, userState, 'platform').appAccess
              : false
          }
          style={{
            width: screens.xl ? `${columnWidth}px` : `${columnWidthSmall}px`,
            maxWidth: screens.xl ? `${columnWidth}px` : `${columnWidthSmall}px`,
          }}
        />
        <Cell
          className={`
            ${borderColorClassName}
            `}
          classes={{
            childDivClass: 'justify-center',
            pClass: 'text-center',
          }}
          title={
            plan
              ? getStructuredPlanData(plan, userState, 'platform')
                  .upgradetoHardcopy
              : ''
          }
          icon={
            plan
              ? getStructuredPlanData(plan, userState, 'platform')
                  .upgradetoHardcopy
                ? false
                : false
              : false
          }
          crossIcon={
            plan
              ? !getStructuredPlanData(plan, userState, 'platform')
                  .upgradetoHardcopy
                ? true
                : false
              : false
          }
          style={{
            width: screens.xl ? `${columnWidth}px` : `${columnWidthSmall}px`,
            maxWidth: screens.xl ? `${columnWidth}px` : `${columnWidthSmall}px`,
          }}
        />
      </div>
    </div>
  );
};

export default SingleColumn;
